module.exports = __webpack_public_path__ + "static/img/0001-XZ-01.dfef8bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0001-XZ-01.jpg
// module id = PdLB
// module chunks = 0